// leaf-town - gfx: canvases, pixel sculpting, bitmap fonts, lighting, presentation
(function () {
  'use strict';
  const G = window.G, W = G.W, H = G.H;

  G.makeCanvas = (w, h) => {
    const c = document.createElement('canvas');
    c.width = Math.max(1, w | 0); c.height = Math.max(1, h | 0);
    c.g = c.getContext('2d');
    c.g.imageSmoothingEnabled = false;
    return c;
  };

  // ---------- colour helpers ----------
  const rgbCache = {};
  G.rgb = (hex) => {
    let c = rgbCache[hex];
    if (!c) {
      const h = hex.length === 4 ? '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3] : hex;
      c = rgbCache[hex] = [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
    }
    return c;
  };
  G.rgba = (hex, a) => { const c = G.rgb(hex); return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')'; };
  G.mix = (h1, h2, t) => {
    const a = G.rgb(h1), b = G.rgb(h2);
    const f = (i) => Math.round(a[i] + (b[i] - a[i]) * t).toString(16).padStart(2, '0');
    return '#' + f(0) + f(1) + f(2);
  };

  // ---------- pixel sculpting (all art in this game is built with these) ----------
  G.pix = (w, h) => {
    const c = G.makeCanvas(w, h), g = c.g;
    const p = {
      c, g, w, h,
      px(x, y, col) { g.fillStyle = col; g.fillRect(x | 0, y | 0, 1, 1); return p; },
      rect(x, y, rw, rh, col) { g.fillStyle = col; g.fillRect(Math.round(x), Math.round(y), Math.round(rw), Math.round(rh)); return p; },
      clear(x, y, rw, rh) { g.clearRect(x | 0, y | 0, rw | 0, rh | 0); return p; },
      // filled ellipse, tested per pixel centre so edges stay crisp
      ell(cx, cy, rx, ry, col) {
        g.fillStyle = col;
        for (let y = Math.floor(cy - ry); y <= Math.ceil(cy + ry); y++) {
          let x0 = null, x1 = null;
          for (let x = Math.floor(cx - rx); x <= Math.ceil(cx + rx); x++) {
            const dx = (x + 0.5 - cx) / rx, dy = (y + 0.5 - cy) / ry;
            if (dx * dx + dy * dy <= 1) { if (x0 === null) x0 = x; x1 = x; }
          }
          if (x0 !== null) g.fillRect(x0, y, x1 - x0 + 1, 1);
        }
        return p;
      },
      // any shape from a predicate
      shape(fn, col) {
        g.fillStyle = col;
        for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) if (fn(x + 0.5, y + 0.5)) g.fillRect(x, y, 1, 1);
        return p;
      },
      line(x0, y0, x1, y1, col) { G.line(g, x0, y0, x1, y1, col); return p; },
      // rows of chars -> pixels via a palette map
      rows(x, y, rows, pal) {
        for (let j = 0; j < rows.length; j++) for (let i = 0; i < rows[j].length; i++) {
          const col = pal[rows[j][i]];
          if (col) { g.fillStyle = col; g.fillRect(x + i, y + j, 1, 1); }
        }
        return p;
      },
      // 1px outline around everything opaque
      outline(col, diag) {
        const d = g.getImageData(0, 0, w, h), a = d.data, hits = [];
        const op = (x, y) => x >= 0 && y >= 0 && x < w && y < h && a[(y * w + x) * 4 + 3] > 20;
        for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
          if (op(x, y)) continue;
          if (op(x - 1, y) || op(x + 1, y) || op(x, y - 1) || op(x, y + 1) ||
            (diag && (op(x - 1, y - 1) || op(x + 1, y - 1) || op(x - 1, y + 1) || op(x + 1, y + 1)))) hits.push(x, y);
        }
        g.fillStyle = col;
        for (let i = 0; i < hits.length; i += 2) g.fillRect(hits[i], hits[i + 1], 1, 1);
        return p;
      },
      // darken the lower-right rim / lighten upper-left: cheap volume
      rim(light, dark) {
        const d = g.getImageData(0, 0, w, h), a = d.data, L = [], D = [];
        const op = (x, y) => x >= 0 && y >= 0 && x < w && y < h && a[(y * w + x) * 4 + 3] > 20;
        for (let y = 0; y < h; y++) for (let x = 0; x < w; x++) {
          if (!op(x, y)) continue;
          if (dark && (!op(x, y + 1) || !op(x + 1, y))) D.push(x, y);
          else if (light && (!op(x, y - 1) || !op(x - 1, y))) L.push(x, y);
        }
        if (light) { g.fillStyle = light; for (let i = 0; i < L.length; i += 2) g.fillRect(L[i], L[i + 1], 1, 1); }
        if (dark) { g.fillStyle = dark; for (let i = 0; i < D.length; i += 2) g.fillRect(D[i], D[i + 1], 1, 1); }
        return p;
      },
      draw(img, x, y) { g.drawImage(img, x | 0, y | 0); return p; },
    };
    return p;
  };

  G.line = (g, x0, y0, x1, y1, col) => {
    x0 = Math.round(x0); y0 = Math.round(y0); x1 = Math.round(x1); y1 = Math.round(y1);
    const dx = Math.abs(x1 - x0), dy = -Math.abs(y1 - y0), sx = x0 < x1 ? 1 : -1, sy = y0 < y1 ? 1 : -1;
    let err = dx + dy, n = 0;
    if (col) g.fillStyle = col;
    for (;;) {
      g.fillRect(x0, y0, 1, 1);
      if ((x0 === x1 && y0 === y1) || n++ > 2000) break;
      const e2 = 2 * err;
      if (e2 >= dy) { err += dy; x0 += sx; }
      if (e2 <= dx) { err += dx; y0 += sy; }
    }
  };
  // pixel-perfect ring / disc
  G.ring = (g, cx, cy, r, col) => {
    cx = Math.round(cx); cy = Math.round(cy); r = Math.round(r);
    if (r <= 0) return;
    g.fillStyle = col;
    let x = r, y = 0, err = 1 - r;
    while (x >= y) {
      g.fillRect(cx + x, cy + y, 1, 1); g.fillRect(cx - x, cy + y, 1, 1); g.fillRect(cx + x, cy - y, 1, 1); g.fillRect(cx - x, cy - y, 1, 1);
      g.fillRect(cx + y, cy + x, 1, 1); g.fillRect(cx - y, cy + x, 1, 1); g.fillRect(cx + y, cy - x, 1, 1); g.fillRect(cx - y, cy - x, 1, 1);
      y++;
      if (err < 0) err += 2 * y + 1; else { x--; err += 2 * (y - x) + 1; }
    }
  };
  G.disc = (g, cx, cy, r, col) => {
    cx = Math.round(cx); cy = Math.round(cy);
    g.fillStyle = col;
    for (let y = -Math.ceil(r); y <= Math.ceil(r); y++) {
      const hw = Math.floor(Math.sqrt(Math.max(0, r * r - y * y)));
      g.fillRect(cx - hw, cy + y, hw * 2 + 1, 1);
    }
  };
  // vertical gradient with ordered dithering between hard colour steps
  const BAYER = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];
  G.ditherGrad = (w, h, stops) => {
    const c = G.makeCanvas(w, h), g = c.g;
    for (let y = 0; y < h; y++) {
      const t = y / (h - 1);
      let i = 0;
      while (i < stops.length - 2 && t > stops[i + 1][0]) i++;
      const a = stops[i], b = stops[i + 1];
      const lt = G.clamp((t - a[0]) / (b[0] - a[0] || 1), 0, 1);
      for (let x = 0; x < w; x += 1) {
        const th = (BAYER[(y & 3) * 4 + (x & 3)] + 0.5) / 16;
        g.fillStyle = lt > th ? b[1] : a[1];
        g.fillRect(x, y, 1, 1);
      }
    }
    return c;
  };

  // tinted copy of a sprite (white flashes, silhouettes)
  const tintMap = new WeakMap();
  G.tint = (img, col) => {
    let m = tintMap.get(img);
    if (!m) tintMap.set(img, (m = {}));
    if (!m[col]) {
      const c = G.makeCanvas(img.width, img.height);
      c.g.fillStyle = col; c.g.fillRect(0, 0, c.width, c.height);
      c.g.globalCompositeOperation = 'destination-in';
      c.g.drawImage(img, 0, 0);
      m[col] = c;
    }
    return m[col];
  };
  G.flipX = (img) => { const c = G.makeCanvas(img.width, img.height); c.g.translate(img.width, 0); c.g.scale(-1, 1); c.g.drawImage(img, 0, 0); return c; };
  // draw sprite centred on x, bottom on y; optional flip / squash / rotation
  G.spr = (g, img, x, y, flip, sx = 1, sy = 1, rot = 0) => {
    if (!img) return;
    const w = img.width, h = img.height;
    if (!flip && sx === 1 && sy === 1 && !rot) { g.drawImage(img, Math.round(x - w / 2), Math.round(y - h)); return; }
    g.save();
    if (rot) { g.translate(Math.round(x), Math.round(y - h / 2)); g.rotate(rot); g.scale(flip ? -sx : sx, sy); g.drawImage(img, -w / 2, -h / 2); }
    else { g.translate(Math.round(x), Math.round(y)); g.scale(flip ? -sx : sx, sy); g.drawImage(img, -w / 2, -h); }
    g.restore();
  };

  // ---------- bitmap fonts (drawn by hand, one row per '/') ----------
  const BIG = {
    A: '.###./#...#/#...#/#####/#...#/#...#/#...#', B: '####./#...#/#...#/####./#...#/#...#/####.', C: '.###./#...#/#..../#..../#..../#...#/.###.',
    D: '####./#...#/#...#/#...#/#...#/#...#/####.', E: '#####/#..../#..../####./#..../#..../#####', F: '#####/#..../#..../####./#..../#..../#....',
    G: '.###./#...#/#..../#.###/#...#/#...#/.###.', H: '#...#/#...#/#...#/#####/#...#/#...#/#...#', I: '###/.#./.#./.#./.#./.#./###',
    J: '..###/...#./...#./...#./...#./#..#./.##..', K: '#...#/#..#./#.#../##.../#.#../#..#./#...#', L: '#..../#..../#..../#..../#..../#..../#####',
    M: '#...#/##.##/#.#.#/#.#.#/#...#/#...#/#...#', N: '#...#/##..#/#.#.#/#..##/#...#/#...#/#...#', O: '.###./#...#/#...#/#...#/#...#/#...#/.###.',
    P: '####./#...#/#...#/####./#..../#..../#....', Q: '.###./#...#/#...#/#...#/#.#.#/#..#./.##.#', R: '####./#...#/#...#/####./#.#../#..#./#...#',
    S: '.####/#..../#..../.###./....#/....#/####.', T: '#####/..#../..#../..#../..#../..#../..#..', U: '#...#/#...#/#...#/#...#/#...#/#...#/.###.',
    V: '#...#/#...#/#...#/#...#/#...#/.#.#./..#..', W: '#...#/#...#/#...#/#.#.#/#.#.#/##.##/#...#', X: '#...#/#...#/.#.#./..#../.#.#./#...#/#...#',
    Y: '#...#/#...#/.#.#./..#../..#../..#../..#..', Z: '#####/....#/...#./..#../.#.../#..../#####',
    a: '..../..../.##./...#/.###/#..#/.###', b: '#.../#.../###./#..#/#..#/#..#/###.', c: '.../.../.##/#../#../#../.##',
    d: '...#/...#/.###/#..#/#..#/#..#/.###', e: '..../..../.##./#..#/####/#.../.###', f: '.##/#../###/#../#../#../#..',
    g: '..../..../.###/#..#/#..#/#..#/.###/...#/.##.', h: '#.../#.../###./#..#/#..#/#..#/#..#', i: '#/./#/#/#/#/#',
    j: '.#/../.#/.#/.#/.#/.#/.#/#.', k: '#.../#.../#..#/#.#./##../#.#./#..#', l: '#/#/#/#/#/#/#',
    m: '...../...../##.#./#.#.#/#.#.#/#.#.#/#.#.#', n: '..../..../###./#..#/#..#/#..#/#..#', o: '..../..../.##./#..#/#..#/#..#/.##.',
    p: '..../..../###./#..#/#..#/#..#/###./#.../#...', q: '..../..../.###/#..#/#..#/#..#/.###/...#/...#', r: '.../.../#.#/##./#../#../#..',
    s: '..../..../.###/#.../.##./...#/###.', t: '#../#../###/#../#../#../.##', u: '..../..../#..#/#..#/#..#/#..#/.###',
    v: '...../...../#...#/#...#/.#.#./.#.#./..#..', w: '...../...../#...#/#.#.#/#.#.#/#.#.#/.#.#.', x: '..../..../#..#/#..#/.##./#..#/#..#',
    y: '..../..../#..#/#..#/#..#/#..#/.###/...#/.##.', z: '..../..../####/...#/.##./#.../####',
    0: '.##./#..#/#.##/##.#/#..#/#..#/.##.', 1: '.#./##./.#./.#./.#./.#./###', 2: '.##./#..#/...#/..#./.#../#.../####',
    3: '###./...#/...#/.##./...#/...#/###.', 4: '#..#/#..#/#..#/####/...#/...#/...#', 5: '####/#.../###./...#/...#/#..#/.##.',
    6: '.##./#.../#.../###./#..#/#..#/.##.', 7: '####/...#/...#/..#./.#../.#../.#..', 8: '.##./#..#/#..#/.##./#..#/#..#/.##.',
    9: '.##./#..#/#..#/.###/...#/...#/.##.',
    ' ': '.../.../.../.../.../.../...', '.': '././././././#', ',': '../../../../../.#/.#/#.', '!': '#/#/#/#/#/./#',
    '?': '.##./#..#/...#/..#./.#../..../.#..', ':': '././#/././#/.', ';': '../../.#/../../.#/.#/#.', "'": '#/#/././././.',
    '"': '#.#/#.#/.../.../.../.../...', '-': '.../.../.../###/.../.../...', '_': '..../..../..../..../..../..../..../####',
    '+': '.../.../.#./###/.#./.../...', '=': '.../.../###/.../###/.../...', '/': '..#/..#/.#./.#./.#./#../#..',
    '\\': '#../#../.#./.#./.#./..#/..#', '(': '.#/#./#./#./#./#./.#', ')': '#./.#/.#/.#/.#/.#/#.',
    '[': '##/#./#./#./#./#./##', ']': '##/.#/.#/.#/.#/.#/##', '{': '.##/.#./.#./#../.#./.#./.##', '}': '##./.#./.#./..#/.#./.#./##.',
    '<': '.../..#/.#./#../.#./..#/...', '>': '.../#../.#./..#/.#./#../...', '*': '.../#.#/.#./#.#/.../.../...',
    '#': '.#.#./.#.#./#####/.#.#./#####/.#.#./.#.#.', '$': '..#../.####/#.#../.###./..#.#/####./..#..',
    '%': '##..#/##.#./...#./..#../.#.../.#.##/#..##', '&': '.##../#..#./#.#../.#.../#.#.#/#..#./.##.#',
    '@': '.###./#...#/#.###/#.#.#/#.###/#..../.###.', '~': '...../...../.#.../#.#.#/...#./...../.....', '|': '#/#/#/#/#/#/#',
    '^': '.#./#.#/.../.../.../.../...', '`': '#./.#/../../../../..',
    '✓': '...../...../....#/...#./#.#../.#.../.....', '✗': '...../#...#/.#.#./..#../.#.#./#...#/.....',
    '▌': '####/####/####/####/####/####/####', '→': '...../..#../...#./#####/...#./..#../.....',
    '←': '...../..#../.#.../#####/.#.../..#../.....', '↑': '..#../.###./#.#.#/..#../..#../..#../.....',
    '↓': '..#../..#../..#../#.#.#/.###./..#../.....', '❦': '...../...##/.####/.####/.###./#..../.....',
    '…': '...../...../...../...../...../...../#.#.#', '•': '../../../##/##/../..',
    '♦': '...../..#../.###./#####/.###./..#../.....', '♥': '...../.#.#./#####/#####/.###./..#../.....',
    '●': '..../..../.##./####/####/.##./....', '○': '..../..../.##./#..#/#..#/.##./....',
    '▸': '.../#../##./###/##./#../...',
  };
  const TINY = {
    A: '.#./#.#/###/#.#/#.#', B: '##./#.#/##./#.#/##.', C: '.##/#../#../#../.##', D: '##./#.#/#.#/#.#/##.', E: '###/#../##./#../###',
    F: '###/#../##./#../#..', G: '.##/#../#.#/#.#/.##', H: '#.#/#.#/###/#.#/#.#', I: '###/.#./.#./.#./###', J: '..#/..#/..#/#.#/.#.',
    K: '#.#/#.#/##./#.#/#.#', L: '#../#../#../#../###', M: '#.#/###/###/#.#/#.#', N: '##./#.#/#.#/#.#/#.#', O: '.#./#.#/#.#/#.#/.#.',
    P: '##./#.#/##./#../#..', Q: '.#./#.#/#.#/###/.##', R: '##./#.#/##./#.#/#.#', S: '.##/#../.#./..#/##.', T: '###/.#./.#./.#./.#.',
    U: '#.#/#.#/#.#/#.#/###', V: '#.#/#.#/#.#/#.#/.#.', W: '#.#/#.#/###/###/#.#', X: '#.#/#.#/.#./#.#/#.#', Y: '#.#/#.#/.#./.#./.#.',
    Z: '###/..#/.#./#../###',
    0: '###/#.#/#.#/#.#/###', 1: '.#./##./.#./.#./###', 2: '##./..#/.#./#../###', 3: '##./..#/.#./..#/##.', 4: '#.#/#.#/###/..#/..#',
    5: '###/#../##./..#/##.', 6: '.##/#../###/#.#/###', 7: '###/..#/.#./.#./.#.', 8: '###/#.#/###/#.#/###', 9: '###/#.#/###/..#/##.',
    ' ': '../../../../..', '.': '././././#', ':': './#/./#/.', '-': '.../.../###/.../...', '/': '..#/..#/.#./#../#..',
    '!': '#/#/#/./#', '?': '##./..#/.#./.../.#.', '+': '.../.#./###/.#./...', '%': '#.#/..#/.#./#../#.#', '_': '.../.../.../.../###',
    '>': '#../.#./..#/.#./#..', '<': '..#/.#./#../.#./..#', '=': '.../###/.../###/...', ',': '././././#', "'": '#/#/././.',
    '(': '.#/#./#./#./.#', ')': '#./.#/.#/.#/#.', '*': '.../#.#/.#./#.#/...', '~': '.../.#./#.#/.../...', '#': '#.#/###/#.#/###/#.#',
    '✓': '.../..#/..#/#.#/.#.', '✗': '.../#.#/.#./#.#/...', '❦': '...#/..##/.###/.##./#...',
    '→': '.../..#/###/..#/...',
    '•': '././#/./.', '$': '.##/##./.#./.##/##.', '"': '#.#/#.#/.../.../...', '&': '.#./#.#/.#./#.#/.##', '@': '###/#.#/#.#/#../###',
    '[': '##/#./#./#./##', ']': '##/.#/.#/.#/##', '|': '#/#/#/#/#', ';': './#/./#/#', '^': '.#./#.#/.../.../...', '\\': '#../#../.#./..#/..#',
  };

  function buildFont(def, rowsN, baseRows) {
    let total = 0;
    const list = [];
    for (const ch in def) {
      const rows = def[ch].split('/');
      const w = rows.reduce((m, r) => Math.max(m, r.length), 0);
      list.push({ ch, rows, w });
      total += w + 1;
    }
    const atlas = G.makeCanvas(total, rowsN), g = atlas.g, map = {};
    let x = 0;
    g.fillStyle = '#fff';
    for (const it of list) {
      for (let j = 0; j < it.rows.length; j++) for (let i = 0; i < it.rows[j].length; i++) if (it.rows[j][i] === '#') g.fillRect(x + i, j, 1, 1);
      map[it.ch] = { x, w: it.w };
      x += it.w + 1;
    }
    return { atlas, map, h: rowsN, base: baseRows, col: {} };
  }
  const fontBig = buildFont(BIG, 9, 7), fontTiny = buildFont(TINY, 5, 5);
  for (const ch of 'abcdefghijklmnopqrstuvwxyz') fontTiny.map[ch] = fontTiny.map[ch.toUpperCase()];
  G.fontBig = fontBig; G.fontTiny = fontTiny;
  function colored(font, col) {
    let c = font.col[col];
    if (!c) {
      c = font.col[col] = G.makeCanvas(font.atlas.width, font.atlas.height);
      c.g.fillStyle = col; c.g.fillRect(0, 0, c.width, c.height);
      c.g.globalCompositeOperation = 'destination-in';
      c.g.drawImage(font.atlas, 0, 0);
    }
    return c;
  }
  function run(g, f, str, x, y, col, sc, sp) {
    const img = colored(f, col);
    for (let i = 0; i < str.length; i++) {
      const gl = f.map[str[i]] || f.map['?'];
      if (str[i] !== ' ') g.drawImage(img, gl.x, 0, gl.w, f.h, x, y, gl.w * sc, f.h * sc);
      x += (gl.w + sp) * sc;
    }
  }
  G.textW = (str, o) => {
    const f = o && o.tiny ? fontTiny : fontBig, sc = (o && o.scale) || 1, sp = o && o.sp !== undefined ? o.sp : 1;
    let w = 0;
    str = String(str);
    for (let i = 0; i < str.length; i++) w += ((f.map[str[i]] || f.map['?']).w + sp) * sc;
    return Math.max(0, w - sp * sc);
  };
  // o: {align:'c'|'r', scale, tiny, shadow:col, outline:col, sp}
  G.text = (g, str, x, y, col, o) => {
    o = o || {};
    str = String(str);
    const f = o.tiny ? fontTiny : fontBig, sc = o.scale || 1, sp = o.sp !== undefined ? o.sp : 1;
    const w = G.textW(str, o);
    if (o.align === 'c') x -= w / 2; else if (o.align === 'r') x -= w;
    x = Math.round(x); y = Math.round(y);
    if (o.outline) {
      for (let dy = -1; dy <= 1; dy++) for (let dx = -1; dx <= 1; dx++) if (dx || dy) run(g, f, str, x + dx * sc, y + dy * sc, o.outline, sc, sp);
      if (o.shadow) for (let dx = -1; dx <= 1; dx++) run(g, f, str, x + dx * sc, y + 2 * sc, o.shadow, sc, sp);
    } else if (o.shadow) run(g, f, str, x + sc, y + sc, o.shadow, sc, sp);
    run(g, f, str, x, y, col || '#fff', sc, sp);
    return w;
  };
  G.wrap = (str, maxW, o) => {
    const out = [];
    for (const para of String(str).split('\n')) {
      let line = '';
      for (const word of para.split(' ')) {
        const t = line ? line + ' ' + word : word;
        if (line && G.textW(t, o) > maxW) { out.push(line); line = word; } else line = t;
      }
      out.push(line);
    }
    return out;
  };

  // ---------- Korean: the Galmuri11 pixel font through fillText, snapped to whole pixels ----------
  const KF = '12px Galmuri11', kc = G.makeCanvas(1, 1).g, kCache = new Map();
  let kReady = false;
  kc.font = KF;
  if (document.fonts) document.fonts.load(KF, '가').then(() => { kReady = document.fonts.check(KF, '가'); kCache.clear(); }, () => {});
  G.kReady = () => kReady;
  G.ktextW = (str) => { kc.font = KF; return Math.round(kc.measureText(String(str)).width); };
  // one cached canvas per string + colour; every pixel is either fully on or off, so it stays crisp when scaled
  function kRun(str, col) {
    const key = col + '|' + str;
    let c = kCache.get(key);
    if (c) return c;
    const w = G.ktextW(str) + 2, h = 14, [r, gg, b] = G.rgb(col);
    c = G.makeCanvas(w, h);
    c.g.font = KF; c.g.textBaseline = 'top'; c.g.fillStyle = col; c.g.fillText(str, 0, 1);   // Galmuri reaches 1px above its 'top'
    const d = c.g.getImageData(0, 0, w, h), a = d.data;
    for (let i = 0; i < a.length; i += 4) { const on = a[i + 3] > 100; a[i] = r; a[i + 1] = gg; a[i + 2] = b; a[i + 3] = on ? 255 : 0; }
    c.g.putImageData(d, 0, 0);
    if (kReady) kCache.set(key, c);
    return c;
  }
  G.kGlyphs = kRun;
  // o: {align:'c'|'r', outline:col, shadow:col}. y is the top of the glyphs (11px tall, descenders below)
  G.ktext = (g, str, x, y, col, o) => {
    o = o || {};
    str = String(str);
    const w = G.ktextW(str);
    if (o.align === 'c') x -= w / 2; else if (o.align === 'r') x -= w;
    x = Math.round(x); y = Math.round(y);
    if (o.outline) { const oc = kRun(str, o.outline); for (let dy = -1; dy <= 1; dy++) for (let dx = -1; dx <= 1; dx++) if (dx || dy) g.drawImage(oc, x + dx, y + dy); }
    if (o.shadow) g.drawImage(kRun(str, o.shadow), x + 1, y + 1);
    g.drawImage(kRun(str, col || '#fff'), x, y);
    return w;
  };
  G.kwrap = (str, maxW) => {
    const out = [];
    for (const para of String(str).split('\n')) {
      let line = '';
      for (const word of para.split(' ')) { const t = line ? line + ' ' + word : word; if (line && G.ktextW(t) > maxW) { out.push(line); line = word; } else line = t; }
      out.push(line);
    }
    return out;
  };

  // notched panel - the only "window" shape the UI uses
  G.panel = (g, x, y, w, h, fill, edge, shade) => {
    x = Math.round(x); y = Math.round(y); w = Math.round(w); h = Math.round(h);
    g.fillStyle = edge;
    g.fillRect(x + 1, y, w - 2, h); g.fillRect(x, y + 1, w, h - 2);
    g.fillStyle = fill;
    g.fillRect(x + 2, y + 1, w - 4, h - 2); g.fillRect(x + 1, y + 2, w - 2, h - 4);
    if (shade) { g.fillStyle = shade; g.fillRect(x + 2, y + h - 2, w - 4, 1); }
  };

  // ---------- display ----------
  const cv = (G.cv = document.getElementById('game'));
  const ctx = cv.getContext('2d', { alpha: false });
  G.buf = G.makeCanvas(W, H); G.g = G.buf.g;        // world layer (gets lit)
  G.uiBuf = G.makeCanvas(W, H); G.ug = G.uiBuf.g;   // hud layer (never lit)
  const LW = W / 4, LH = H / 4;
  const lightC = G.makeCanvas(LW, LH), glowC = G.makeCanvas(LW, LH), vig = G.makeCanvas(LW, LH);
  lightC.g.imageSmoothingEnabled = glowC.g.imageSmoothingEnabled = true;
  (() => {
    const g = vig.g, gr = g.createRadialGradient(LW / 2, LH / 2, LH * 0.45, LW / 2, LH / 2, LW * 0.72);
    gr.addColorStop(0, 'rgba(8,4,14,0)'); gr.addColorStop(1, 'rgba(8,4,14,0.5)');
    g.fillStyle = gr; g.fillRect(0, 0, LW, LH);
  })();
  G.ambient = null;   // multiply colour for darkness, null = fully lit
  G.lights = [];
  // screen-space light. a = how much darkness it removes, glow = additive bloom
  G.light = (x, y, r, col, a, glow) => {
    if (G.lights.length < 140 && x > -r && y > -r && x < W + r && y < H + r) G.lights.push({ x, y, r, col: col || '#ffffff', a: a === undefined ? 1 : a, glow: glow === undefined ? 0.22 : glow });
  };
  function blob(g, l, a, rs) {
    const x = l.x / 4, y = l.y / 4, r = Math.max(1, (l.r * rs) / 4);
    const gr = g.createRadialGradient(x, y, 0, x, y, r);
    gr.addColorStop(0, G.rgba(l.col, a)); gr.addColorStop(0.5, G.rgba(l.col, a * 0.42)); gr.addColorStop(1, G.rgba(l.col, 0));
    g.fillStyle = gr; g.fillRect(x - r, y - r, r * 2, r * 2);
  }
  G.present = () => {
    const w = cv.width, h = cv.height, L = G.lights;
    ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over'; ctx.imageSmoothingEnabled = false;
    ctx.drawImage(G.buf, 0, 0, w, h);
    if (G.ambient) {
      const lg = lightC.g;
      lg.globalCompositeOperation = 'source-over'; lg.fillStyle = G.ambient; lg.fillRect(0, 0, LW, LH);
      lg.globalCompositeOperation = 'lighter';
      for (const l of L) if (l.a > 0) blob(lg, l, l.a, 1);
      ctx.imageSmoothingEnabled = true; ctx.globalCompositeOperation = 'multiply';
      ctx.drawImage(lightC, 0, 0, w, h);
    }
    if (L.length) {
      const gg = glowC.g;
      gg.globalCompositeOperation = 'source-over'; gg.clearRect(0, 0, LW, LH);
      gg.globalCompositeOperation = 'lighter';
      for (const l of L) if (l.glow > 0) blob(gg, l, l.glow, 0.75);
      ctx.imageSmoothingEnabled = true; ctx.globalCompositeOperation = 'lighter';
      ctx.drawImage(glowC, 0, 0, w, h);
    }
    ctx.globalCompositeOperation = 'source-over'; ctx.imageSmoothingEnabled = true;
    ctx.drawImage(vig, 0, 0, w, h);
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(G.uiBuf, 0, 0, w, h);
    L.length = 0;
  };
  function resize() {
    const dpr = window.devicePixelRatio || 1;
    const host = cv.parentElement;              // fit the box we were given (the page may add gutters)
    const s = Math.max(0.25, Math.min((host.clientWidth || window.innerWidth) / W, (host.clientHeight || window.innerHeight) / H));
    const K = G.clamp(Math.ceil(s * dpr - 0.01), 1, 10);
    if (cv.width !== W * K) { cv.width = W * K; cv.height = H * K; }
    cv.style.width = Math.floor(W * s) + 'px'; cv.style.height = Math.floor(H * s) + 'px';
    G.K = K;
  }
  window.addEventListener('resize', resize);
  resize();
  G.toggleFullscreen = () => {
    if (document.fullscreenElement) document.exitFullscreen();
    else if (document.documentElement.requestFullscreen) document.documentElement.requestFullscreen().catch(() => {});
  };

  // ---------- screen wipe: a field of growing diamonds ----------
  // t 0..1 = how covered the screen is; dir +1 sweeps left->right, -1 right->left
  G.wipe = (g, t, col, dir) => {
    if (t <= 0) return;
    g.fillStyle = col || '#0d0a12';
    if (t >= 1) { g.fillRect(0, 0, W, H); return; }
    const S = 16, cols = W / S + 1, rows = Math.ceil(H / S) + 1;
    for (let i = 0; i < cols; i++) {
      const k = dir < 0 ? 1 - i / cols : i / cols;
      const p = G.clamp(t * 1.9 - k * 0.9, 0, 1);
      if (p <= 0) continue;
      const r = Math.ceil(p * (S + 2));
      for (let j = 0; j < rows; j++) {
        const cx = i * S, cy = j * S + ((i & 1) ? S / 2 : 0) - 4;
        for (let dy = -r; dy <= r; dy++) { const hw = r - Math.abs(dy); g.fillRect(cx - hw, cy + dy, hw * 2 + 1, 1); }
      }
    }
  };
})();

